import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { CustomMaskedInputWrapper, InputControls } from '..';
import { CustomFormItem } from '../../../custom_shared/components';
import { InputModel } from '../../models';
import { InputWithMeta } from '../../componentTypes';
import { FieldValidators } from '../../misc';
import { Utils } from '../../../custom_shared/misc';

// Please note that this is a generic component if behavior for your input is different - create a new independent component (like BusinessTypeInput.tsx etc.)

interface Props {
    label: string;
    input: InputModel;
}

const GenericUnlimitedInput: InputWithMeta<Props> = ({ label, input }) => {
    React.useEffect(() => {
        if (FieldValidators.isInvalidUnlimitedFieldValue(input.value)) {
            input.setValue(null);
        }
    }, [input]);

    return (
        <CustomFormItem
            name={input.guid}
            required={input.required}
            customValidator={(...args) => FieldValidators.unlimitedFieldValidator(...args)}
            getValueFromEvent={event => event.target.value.replace(/,/g, '')}
            messageStyle={{ width: 305 }}
            isReadOnly={input.isReadOnly}
        >
            <CustomMaskedInputWrapper
                input={input}
                label={label}
                topRightNode={<InputControls input={input} />}
                reformat={params => Utils.reformatMaskedInput(params)}
            />
        </CustomFormItem>
    );
};

GenericUnlimitedInput.meta = {
    inputType: InputModel.name
};

export default observer(GenericUnlimitedInput);
